import React from 'react';
import Button from './Form/Button';
import { Icon, Icons } from './Icon';
import { Link } from 'react-router-dom';

type Props = {
  iWillLogo: string;
  iWillPlan: string;
  iWillContent: string;
  iWillPlanId: number;
};

export default function IWillType({
  iWillLogo,
  iWillPlan,
  iWillContent,
  iWillPlanId
}: Props) {
  return (
    <>
      <div className="relative flex h-[30rem] flex-col overflow-hidden rounded-[6px] bg-[#F9F9F9] p-6">
        <header className="mb-6">
          <h4 className="mb-5 text-xl  text-slate-900 dark:text-slate-300  ">
            <img src={iWillLogo} className="mb-3 w-20" />
          </h4>
          <div
            className="relative mb-5 flex items-center space-x-4 text-slate-900 
          rtl:space-x-reverse dark:text-slate-300  "
          >
            <p className="my-3 font-inter text-xl font-bold text-[#1E063E]">
              {iWillPlan}
            </p>
          </div>
        </header>
        <div className="space-y-4">
          <p className="font-circular text-lg font-normal text-[#5C6B7E]">
            {iWillContent}
          </p>
        </div>
        <div className="absolute bottom-0 left-0 mb-10">
          <Link to={`/get-started/setup-account/${iWillPlanId}`}>
            <Button
              variant="transparent"
              size="md"
              iconPosition="left"
              iconLabelSpacing={20}
              icon={<Icon name={Icons.ArrowRightBG} />}
              className="mt-10 w-[12rem] rounded p-[0.1rem] text-[#FF6600]"
              label="Get Started"
            ></Button>
          </Link>
        </div>
      </div>
    </>
  );
}
